// LMS Logs translations for React Admin resource
export const lmsLogsResource = {
  name: 'LMS Logs',
  fields: {
    id: 'ID',
    decisionTimestamp: 'Decision Time',
    triggerReason: 'Trigger Reason',
    loadGroup: 'Load Group',
    ocppServer: 'OCPP Server',
    allocationStrategy: 'Strategy',
    chargers: 'Chargers',
    powerAllocation: 'Power Allocation',
    profiles: 'Charging Profiles',
    executionTime: 'Execution',
    details: 'Details',
    activeChargers: 'Active Chargers',
    pendingChargers: 'Pending Chargers',
    totalRequestedCurrent: 'Requested Current',
    availableCurrent: 'Available Current',
    utilizationPercent: 'Utilization %',
    totalAllocatedCurrent: 'Allocated Current',
    profilesSent: 'Profiles Sent',
    profilesAccepted: 'Profiles Accepted',
    profilesRejected: 'Profiles Rejected',
    executionTimeMs: 'Execution Time (ms)',
    error: 'Error',
    loadGroupId: 'Load Group ID',
    ocppServerId: 'OCPP Server ID',
    triggerDetails: 'Trigger Details',
    allocations: 'Allocations',
  },
};

// Custom LMS logs translations for components
export const lmsLogs = {
  subtitle: 'View Load Management System decision logs and power allocation history',
  list: {
    title: 'LMS Decision Logs',
    filters: {
      search: 'Search',
      triggerReason: 'Trigger Reason',
      allocationStrategy: 'Allocation Strategy',
      loadGroupId: 'Load Group ID',
      ocppServerId: 'OCPP Server ID',
      startDate: 'Start Date',
      endDate: 'End Date',
    },
    empty: {
      title: 'No LMS logs found',
      subtitle: 'LMS decision logs will appear here once load management begins.',
    },
  },
  triggers: {
    SESSION_START: 'Session Start',
    SESSION_STOP: 'Session Stop',
    STATUS_CHANGE: 'Status Change',
    PERIODIC: 'Periodic Rebalance',
    MANUAL: 'Manual Trigger',
  },
  strategies: {
    equal: 'Equal Distribution',
    equal_distribution: 'Equal Distribution',
    queue: 'Queue (FCFS)',
    member_priority: 'Member Priority',
  },
  chargers: {
    active: '{{count}} Active',
    pending: '{{count}} Pending',
  },
  profiles: {
    success: '{{accepted}}/{{sent}} ({{rate}}%)',
    rejected: '{{count}} Rejected',
  },
  status: {
    success: 'Success',
    error: 'Error',
    partial: 'Partial Success',
  },
  details: {
    noDetails: 'No details',
    charger: 'Charger: {{id}}',
    inefficiency: 'Inefficiency: {{percent}}%',
    transaction: 'Transaction: {{id}}',
    statusChange: '{{oldStatus}} → {{newStatus}}',
  },
  notifications: {
    exportSuccess: 'LMS logs exported successfully',
    exportError: 'Failed to export LMS logs',
  },
  powerInfo: {
    allocated: 'Allocated',
    available: 'Available',
    requested: 'Requested',
    utilization: 'Utilization',
  },
  show: {
    title: 'LMS Decision Details',
    basicInfo: 'Basic Information',
    triggerDetails: 'Trigger Details',
    noAllocations: 'No power allocations were made in this decision',
    chargerStation: 'Charger / Station',
    currentLimit: 'Current Limit',
    reductionFactor: 'Reduction Factor',
    loadGroupInfo: 'Load Group Information',
    powerAllocation: 'Power Allocation',
    chargerStats: 'Charger Stats',
    activeChargers: 'Active Chargers',
    allocated: 'Allocated Current',
    currentAllocation: 'Current Allocation',
    utilization: 'Utilization',
    profileStats: 'Charging Profiles',
    allocations: 'Power Allocations',
    errorDetails: 'Error Details',
  },
};